// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyD-BeQhKbe6_gSF6GLYCrz-p_KS7RlKTtQ",
    authDomain: "uc-online-df7b6.firebaseapp.com",
    projectId: "uc-online-df7b6",
    storageBucket: "uc-online-df7b6.firebasestorage.app",
    messagingSenderId: "1051413076005",
    appId: "1:1051413076005:web:19c7ea5ec7491a9836c7cc"
  };
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

document.getElementById('quote-form').addEventListener('submit', async function (e) {
    e.preventDefault(); // Prevent form submission

    const name = document.getElementById('cname').value;
    const mail = document.getElementById('cemail').value;
    const product = document.getElementById('cproduct').value;
    const comment = document.getElementById('ccomment').value;

    try {
        await db.collection('quote-entries').add({
            name: name,
            mail: mail,
            product: product,
            comment: comment,
            created: firebase.firestore.FieldValue.serverTimestamp(),
        });
        //alert('Quote request submitted successfully!');
    } catch (error) {
        console.error('Error submitting quote request:', error);
        alert('Failed to submit quote request.');
    }
});
